/**
 * Custom On-Hover Card Component
 * Handles mobile tap-to-toggle functionality
 * Desktop: CSS :hover handles the transition
 * Mobile: Tap to toggle between default and hover states
 */

class CustomOnHoverCard extends HTMLElement {
  constructor() {
    super();
    this.isMobile = window.matchMedia('(max-width: 767px)');
    this.handleClick = this.handleClick.bind(this);
    this.handleOutsideClick = this.handleOutsideClick.bind(this);
    this.handleMediaChange = this.handleMediaChange.bind(this);
  }

  connectedCallback() {
    this.init();
  }

  disconnectedCallback() {
    this.destroy();
  }

  init() {
    // Only add click listener on mobile
    if (this.isMobile.matches) {
      this.enableMobileMode();
    }

    // Listen for viewport changes
    this.isMobile.addEventListener('change', this.handleMediaChange);
  }

  destroy() {
    this.disableMobileMode();
    this.isMobile.removeEventListener('change', this.handleMediaChange);
  }

  handleMediaChange(e) {
    if (e.matches) {
      this.enableMobileMode();
    } else {
      this.disableMobileMode();
    }
  }

  enableMobileMode() {
    this.addEventListener('click', this.handleClick);
    document.addEventListener('click', this.handleOutsideClick);
  }

  disableMobileMode() {
    this.removeEventListener('click', this.handleClick);
    document.removeEventListener('click', this.handleOutsideClick);
    this.classList.remove('is-active');
  }

  handleClick(e) {
    // Prevent toggling if clicking on a link/button inside
    if (e.target.closest('a, button')) {
      return;
    }

    e.stopPropagation();
    
    // Close other open cards
    document.querySelectorAll('custom-on-hover-card.is-active').forEach(card => {
      if (card !== this) {
        card.classList.remove('is-active');
      }
    });

    // Toggle this card
    this.classList.toggle('is-active');
  }

  handleOutsideClick(e) {
    // Close if clicking outside this card
    if (!this.contains(e.target)) {
      this.classList.remove('is-active');
    }
  }
}

// Register the custom element
if (!customElements.get('custom-on-hover-card')) {
  customElements.define('custom-on-hover-card', CustomOnHoverCard);
}
